/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetReservableSpacePathParameters } from 'api/actions/get-reservable-space/get-reservable-space-path-parameters';
import { GetReservableSpaceResponse } from 'api/actions/get-reservable-space/get-reservable-space-response';

type GetReservableSpaceQueryParameters = Record<string, any>;

/**
 * The path of the GetReservableSpace action.
 */
export const getReservableSpaceActionPath = new SweetPath<keyof GetReservableSpacePathParameters>(
  '/reservations/spaces/{id}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetReservableSpace actions.
 */
export default function createGetReservableSpaceAction(axios: AxiosInstance) {
  return function getReservableSpaceAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetReservableSpacePathParameters;
    query?: GetReservableSpaceQueryParameters;
  }) {
    const path = getReservableSpaceActionPath.insert(parameters);

    return axios.get<GetReservableSpaceResponse, GetReservableSpaceResponse>(path, { params: query, headers });
  };
}
